var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasMultipleSections
    ? _c(
        "div",
        { staticClass: "sensor-type-legend d-flex align-center" },
        [
          _vm._l(_vm.sections, function (section) {
            return [
              _c(
                "svg",
                {
                  key: "color-" + section.type,
                  staticClass: "legend-marker",
                  attrs: {
                    viewBox: _vm.ARROW_MARKER_VIEWBOX,
                    "data-testid": "sensor-type-legend-color",
                    "aria-hidden": "true",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: _vm.ARROW_MARKER_PATH,
                      fill: _vm.colorFor(section.type),
                      stroke: "black",
                      "stroke-width": _vm.ARROW_MARKER_STROKE_WIDTH,
                      transform: _vm.ARROW_MARKER_LEGEND_TRANSFORM,
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  key: "label-" + section.type,
                  attrs: { "data-testid": "sensor-type-legend-label" },
                },
                [_vm._v("\n      " + _vm._s(section.label) + "\n    ")]
              ),
              _vm._v(" "),
              _vm.isRatSense(section.type) && !_vm.isExporting
                ? _c(
                    "v-tooltip",
                    {
                      key: "notice-" + section.type,
                      attrs: { bottom: "", "max-width": "300", "z-index": 15 },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "v-icon",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          "x-small": "",
                                          "aria-label": _vm.ratSenseNotice,
                                          "data-testid":
                                            "rat-sense-notice-icon",
                                        },
                                      },
                                      "v-icon",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _vm._v(
                                      "\n          mdi-information-outline\n        "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.ratSenseNotice))]),
                    ]
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }